<template>
  <div class="main">
    <div class="content">
      <div class="msg">
        <i class="el-icon-warning"></i
        >尊敬的用户，您好，为了您的账号安全，请设置登录密码！
      </div>
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="query"
        label-width="125px"
      >
        <el-form-item label="登录账号" style="margin-top: 20px;">
          <p style="font-weight: 700;">
            {{ phoneNumber }}
          </p>
          <div class="info fontstyle">
            如忘记密码，可联系管理员进行重置或 <span>自主找回</span>
          </div>
        </el-form-item>
        <el-form-item label="用户名称" style="margin-top: 20px;">
          <el-input
            v-model="query.name"
            placeholder="请输入"
            style="width: 350px"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" style="margin-top: 20px;" prop="password1">
          <el-input
            v-model="query.password1"
            placeholder="请输入"
            style="width: 350px"
            @input="passwordInput"
            type="password"
          ></el-input>
          <div class="fontstyle">
            新密码长度8-20位，且必须包含数字、小写字母、大写字母
          </div>
          <div class="password_line">
            <span class="fontstyle" style="margin-right:10px">密码强度</span>
            <span
              v-for="(item, index) in passwordStrength"
              :key="index"
              class="line"
              :style="{ background: item.color }"
            ></span>
            <span :style="{ color: fontStyle.color, marginLeft: '10px' }">
              {{ fontStyle.value }}
            </span>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" style="margin-top: 20px" prop="password">
          <el-input
            v-model="query.password"
            placeholder="请输入"
            style="width: 350px"
            @blur="passwordBlurRepeat"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin: 20px 0 0 10%;">
          <el-button
            style="width: 120px"
            type="primary"
            size=""
            autofocus
            :disabled="!checked"
            @click="save()"
            >保存</el-button
          >
          <el-button
            style="margin-left: 20px; width: 120px"
            size=""
            @click="cancel()"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validateIdcard } from "@/utils/validate.js";
import { handleChangepassword } from "@/api/register/index.js";
export default {
  props: {},
  data() {
    return {
      fontStyle: {
        color: "",
        value: "",
      },
      checked: true,
      passwordStrength: [
        { id: "1", color: "#f0f4f6" },
        { id: "2", color: "#f0f4f6" },
        { id: "3", color: "#f0f4f6" },
      ], //密码强度
      query: {
        password1: "",
        password: "", //组织统一执照代码18位  201961100220267271
        name: "",
      },
      rules: {
        password1: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 8, max: 20, message: "密码过于简单,长度8-20位!", trigger: "change" },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[0-9].*)/;
              console.log(passwordreg.test(value));
              if (!passwordreg.test(value)) {
                callback(new Error("密码必须包含数字、小写字母、大写字母!"));
              } else {
                callback();
              }
            },
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 8, max: 20, message: "密码长度8-20位!", trigger: "blur" },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var passwordreg = /(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[0-9].*)/;
              console.log(passwordreg.test(value));
              if (!passwordreg.test(value)) {
                callback(new Error("密码必须包含数字、小写字母、大写字母!"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      phoneNumber: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.phoneNumber = sessionStorage.getItem("phoneNumber") || "无账号信息";
  },
  methods: {
    passwordInput(value) {
      this.query.password1 = value;
      if (value.length > 0 && value.length <= 10) {
        this.passwordStrength = [{ id: "1", color: "#FF5050" }];
        this.fontStyle = {
          color: "#FF5050",
          value: "弱",
        };
      } else if (value.length > 10 && value.length <= 15) {
        this.passwordStrength = [
          { id: "1", color: "#4991E1" },
          { id: "2", color: "#4991E1" },
        ];
        this.fontStyle = {
          color: "#4991E1",
          value: "中",
        };
      } else if (value.length > 15 && value.length <= 20) {
        this.passwordStrength = [
          { id: "1", color: "#54D27D" },
          { id: "2", color: "#54D27D" },
          { id: "3", color: "#54D27D" },
        ];
        this.fontStyle = {
          color: "#54D27D",
          value: "强",
        };
      } else {
        this.passwordStrength = [
          { id: "1", color: "#f0f4f6" },
          { id: "2", color: "#f0f4f6" },
          { id: "3", color: "#f0f4f6" },
        ] //密码强度
        this.fontStyle = {
          color: "",
          value: "",
        }
      }
    },
    passwordBlurRepeat() {
      if (this.query.password1 != this.query.password) {
        this.$message({
          type: "error",
          message: "密码输入不一致",
        });
      }
    },
    async save() {
      this.$refs["rulesForm"].validate(async (valid) => {
        if (valid) {
          let params = {
            loginPlatformCode:
              sessionStorage.getItem("loginPlatformCode") || "888880", //发送验证码后返回的key
            platformCode: sessionStorage.getItem("platformCode") || "888880", //机构名称
            usessionid: sessionStorage.getItem("usessionId") || "", //组织统一社会信用代码
            // registerKey: sessionStorage.getItem("registerKey") || "",
            phoneNumber: this.phoneNumber || "",
            password: this.query.password || "", //组织统一社会信用代码
            name: this.query.name, //用户名称
          };
          const { result, desc } = await handleChangepassword(params);
          if (result === "000000") {
            this.$message({
              type: "success",
              message: "修改密码成功",
            });
            window.location.href = `https://assfe.tianyuyun.com/?usessionId=${sessionStorage.getItem(
              "usessionId"
            )}`;
          } else {
            this.$message({
              type: "error",
              message: desc,
            });
          }
        } else {
          if (this.query.password == "" || this.query.password1 == "") {
            this.$message({
              type: "error",
              message: "请输入必填项!",
            });
          } else {
            this.$message({
              type: "error",
              message: "密码格式不符合规范!",
            });
          }
        }
      });
    },
    cancel() {
      this.$emit("changeStep", 1);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 4%;
  .content {
    width: 650px;
    .msg {
      margin: 0 auto;
      width: 550px;
      height: 40px;
      margin-bottom: 35px;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFang SC;
      background: #fef2f2;
      border: 1px solid #ff4400;
    }
    .el-form {
      width: 550px;
      margin: 0 auto;
      .info {
        span {
          color: #4991e1;
          cursor: pointer;
        }
      }
      .fontstyle {
        font-size: 14px;
        color: #a3a4a5;
      }
      .password_line {
        display: flex;
        align-items: center;
        .line {
          display: inline-block;
          margin: 0 2px;
          width: 100px;
          height: 20px;
        }
        // span:nth-child(2) {
        //   border-radius: 5px 0 0 5px;
        // }
        // span:last-child {
        //   border-radius: 0 5px 5px 0;
        // }
      }
    }
  }
}

::v-deep .el-form .el-input__inner {
  height: 40px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
.el-icon-warning {
  margin: 0 10px;
  color: #ff4400;
}
</style>
